import { FilteredCreditApplication, useRefreshCreditReport } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
interface Props {
  creditApp: FilteredCreditApplication
}
const MultipleCreditReportsFound = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [refreshCreditReport, isRefreshing] = useRefreshCreditReport()
  const [isChecked, setIsChecked] = useState(false)
  const applicantHasMultipleReports = creditApp.applicant.multipleCreditReportsFound

  const handleRefreshClick = async () => {
    await refreshCreditReport({
      creditApplicationId: creditApp.id,
      isApplicant: applicantHasMultipleReports,
      versionTag: creditApp.versionTag,
      financingProgram: EFinancingProgram.B2c,
    })
  }

  return (
    <main className="general-message">
      <h4 className="subtitle">{t('common.actionRequired')}</h4>
      <div style={{ textAlign: 'center' }}>
        <h1>{t('multipleCreditReportsFound.title')}</h1>
      </div>
      {!creditApp.applicant.hasApplicantRefreshedCreditReport && (
        <>
          <div className="paragraph">
            <h3>
              <Trans i18nKey="multipleCreditReportsFound.subtitle" />
            </h3>
          </div>
          <div className="paragraph">
            <p>{t('multipleCreditReportsFound.preventingProcessing')}</p>
            <p>{t('multipleCreditReportsFound.resolveIssue')}</p>
            <ul style={{ listStyle: 'number', margin: '0 1.5em' }}>
              <li>
                <Trans i18nKey="multipleCreditReportsFound.step1" />
              </li>
              <br />
              <li>
                <Trans i18nKey="multipleCreditReportsFound.step2" />
              </li>
              <br />
              <li>
                <Trans i18nKey="multipleCreditReportsFound.step3" />
                <ul style={{ listStyle: 'disc', margin: '0 1.5em' }}>
                  <li style={{ whiteSpace: 'nowrap' }}>
                    {t('multipleCreditReportsFound.uniqueIdAndCreationDate', {
                      uniqueId: creditApp.applicant.softHitCreditReportUniqueId,
                      reportCreationDate: creditApp.applicant.softHitReportFileSinceDate,
                    })}
                  </li>
                  <li style={{ whiteSpace: 'nowrap' }}>
                    {t('multipleCreditReportsFound.uniqueIdAndCreationDate', {
                      uniqueId: creditApp.applicant.hardHitCreditReportUniqueId,
                      reportCreationDate: creditApp.applicant.hardHitReportFileSinceDate,
                    })}
                  </li>
                </ul>
              </li>
              <br />
            </ul>
            <h4>{t('multipleCreditReportsFound.onceDone')}</h4>

            <div className="control-group">
              <input
                required
                type="checkbox"
                id="acceptConditions"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                onInvalid={(e) => e.currentTarget.setCustomValidity(t('common.acceptConditions'))}
              />
              <label style={{ fontSize: '1.8rem', fontWeight: 'inherit' }} htmlFor="acceptConditions">
                <Trans i18nKey="multipleCreditReportsFound.haveYoucContactedEquifax" />
              </label>
            </div>
            <button
              type="button"
              className="btn btn-blue btn-simple"
              onClick={handleRefreshClick}
              disabled={!isChecked || isRefreshing}
            >
              {t('multipleCreditReportsFound.creditRefresh')}
            </button>
          </div>
        </>
      )}
      <div className="paragraph">
        {creditApp.applicant.hasApplicantRefreshedCreditReport && (
          <h4>{t('multipleCreditReportsFound.creditReportAlreadyRefreshed')}</h4>
        )}
        <br />
        <p>
          <Trans i18nKey="multipleCreditReportsFound.furthurAssistance" />
        </p>
      </div>
    </main>
  )
}

export default MultipleCreditReportsFound
